module.exports = __webpack_public_path__ + "static/img/img_notice2.a7940464.png";